import request from './request';

export async function list(
  page: number,
  perPage: number,
  email?: string,
  firstName?: string,
  secondName?: string,
  phone?: string,
  types?: string[],
  statuses?: string[],
  course?: string,
  courseIds?: string[],
  isStudent?: boolean,
  sortColumn?: string,
  sortOrder?: string,
  createdAtFilter?: number[],
  updatedAtFilter?: number[]
) {
  return request('GET', '/api/requests', {
    page,
    perPage,
    email,
    types,
    firstName,
    secondName,
    phone,
    statuses,
    course,
    courseIds,
    isStudent,
    sortColumn,
    sortOrder,
    createdAtFilter,
    updatedAtFilter,
  });
}

export async function update(id: string, toUpdate: Record<string, unknown>) {
  return request('POST', `/api/requests/${id}`, toUpdate);
}

export async function remove(id: string) {
  return request('DELETE', `/api/requests/${id}`);
}

export async function getTypes(): Promise<{
  types: { value: string; label: string }[];
}> {
  return request('GET', '/api/requests/types');
}

export async function getStatuses(): Promise<{
  statuses: { value: number; label: string }[];
}> {
  return request('GET', '/api/requests/statuses');
}

export async function getQueueEntries(
  id: string,
  sortColumn?: string,
  sortOrder?: string
): Promise<{ queue: any[] }> {
  return request(
    'GET',
    `/api/requests/${id}/queue?sortColumn=${sortColumn}&sortOrder=${sortOrder}`
  );
}

export async function addToCoursesQueues(
  id: string,
  courseIds: string[]
): Promise<{ queue: any[] }> {
  return request('POST', `/api/requests/${id}/queue`, { courseIds });
}

export async function removeFromCoursesQueues(
  id: string,
  courseIds: string[]
): Promise<{ queue: any[] }> {
  return request('DELETE', `/api/requests/${id}/queue`, { courseIds });
}

export async function makeStudent(id: string) {
  return request('POST', `/api/requests/${id}/student`);
}
